import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WRONG_SITE_PENDING_KEY, readOrganizationSiteLink } from '@shared/core';

@Component({
	selector: 'spaq-app-wrong-site',
	standalone: true,
	imports: [CommonModule],
	template: `
		<h4 class="text-center bg-warning p-4">Ce compte doit utiliser le site de son organisation.</h4>
		<p *ngIf="siteUrl" class="text-center mt-4">
			Veuillez poursuivre sur <a [href]="siteUrl">{{ siteHost }}</a>.
		</p>
	`,
	styles: []
})
export class AppWrongSiteComponent implements OnInit {
	siteUrl: string | null = null;
	siteHost: string | null = null;

	constructor(private route: ActivatedRoute) {}

	ngOnInit() {
		sessionStorage.removeItem(WRONG_SITE_PENDING_KEY);
		this.siteUrl = readOrganizationSiteLink(this.route.snapshot.queryParamMap.get('site'));
		this.siteHost = this.siteUrl ? new URL(this.siteUrl).hostname : null;
	}
}
